import { StageClassesRow } from "../components/field/stage/StageClassesView"
export const rowRenderers = {
    StageClassesRow,
}
